export const buildContactFormUrl = ({
    schoolName,
    studentFirstName,
    studentLastName,
    userFirstName,
    userLastName,
    userEmail,
    pleaseChoose,
    formId = '251966567485071'
}) => {
    const baseUrl = `https://eu.jotform.com/form/${formId}`;
    const params = new URLSearchParams();

    if (pleaseChoose) {
        params.append('pleaseChoose', pleaseChoose);
    }

    if (schoolName) {
        params.append('whichAdmicity', schoolName);
    }

    if (studentFirstName) {
        params.append('pleaseEnter[first]', studentFirstName);
    }

    if (studentLastName) {
        params.append('pleaseEnter[last]', studentLastName);
    }

    if (userFirstName) {
        params.append('pleaseEnter12[first]', userFirstName);
    }

    if (userLastName) {
        params.append('pleaseEnter12[last]', userLastName);
    }

    if (userEmail) {
        params.append('pleaseEnter13', userEmail);
    }

    return `${baseUrl}?${params.toString()}`;
};